module.exports = __webpack_public_path__ + "img/logo_flowit.b25fc443.png";